import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon, InformationCircleIcon } from "@heroicons/react/24/solid";
import { Dispatch, SetStateAction } from "react";
import { classNames } from "../../../utils/lib";

type Props = {
  setValue: Dispatch<SetStateAction<string>>;
  value: string;
  data: Array<{ name: string; description: string }>;
};

const ShippingMethod = ({ setValue, value, data }: Props) => {
  const selectedItem = data.find((item) => item.name === value);

  return (
    <div>
      <RadioGroup value={value} onChange={(e) => setValue(e)}>
        <RadioGroup.Label className="text-base font-medium text-gray-900">
          Delivery method
        </RadioGroup.Label>

        <div className="mt-4 grid grid-cols-2 gap-4">
          {data.map((item, i) => (
            <RadioGroup.Option
              key={i + 1}
              value={item.name}
              className={({ checked }) =>
                classNames(
                  "relative bg-white border-2 rounded-full px-6 py-4 flex cursor-pointer focus:outline-none transition-all",
                  checked ? "border-gray-600 bg-gray-50" : "border-gray-300 hover:border-gray-400"
                )
              }
            >
              {({ checked }) => (
                <div className="flex items-center w-full gap-3">
                  <div
                    className={classNames(
                      "h-6 w-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all",
                      checked ? "border-blue-600 bg-blue-600" : "border-gray-300 bg-white"
                    )}
                  >
                    {checked && <CheckCircleIcon className="h-4 w-4 text-white" />}
                  </div>
                  <RadioGroup.Label as="span" className="block text-sm font-medium text-gray-900 cursor-pointer">
                    {item.name}
                  </RadioGroup.Label>
                </div>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>

      {selectedItem && (
        <div className="mt-6 flex gap-3 p-4 bg-gray-50 rounded-lg">
          <InformationCircleIcon className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-gray-600">{selectedItem.description}</p>
        </div>
      )}
    </div>
  );
};

export default ShippingMethod;
